import React, { FC } from 'react';
import { SelectOption } from 'shared-types/Common';
import SelectField from '../../../../components/FormElements/BlockSelectField';
import { ClassFiltersColumn } from '../Filters.styles';
import { CategoryPickerWrapper, DesktopLabel } from './CategoriesPicker.styles';
import { useTranslations } from '@lang';

export type CategoriesPickerProps = {
  showCategoriesPicker?: boolean;
  isInsideModal?: boolean;
  disableCategorySelect?: boolean;
  categories?: SelectOption[];
  selectedCategory?: SelectOption;
  label?: string;
  onCategoryChange?: (selectedCategory: SelectOption) => void;
};

export const CategoriesPicker: FC<CategoriesPickerProps> = ({
  showCategoriesPicker = false,
  isInsideModal = false,
  disableCategorySelect = false,
  categories = [],
  selectedCategory,
  label = '',
  onCategoryChange = () => {},
}) => {
  const { t } = useTranslations();
  return showCategoriesPicker ? (
    <ClassFiltersColumn>
      <DesktopLabel>{t('common.category')}</DesktopLabel>
      <CategoryPickerWrapper isInsideModal={isInsideModal}>
        <SelectField
          isDisabled={disableCategorySelect || !categories.length}
          value={selectedCategory}
          options={categories}
          onChange={onCategoryChange}
          label={label}
        />
      </CategoryPickerWrapper>
    </ClassFiltersColumn>
  ) : null;
};
